<template>
  <div>
    <!-- <div class="loader" v-if="isLoading">
      <CSpinner variant="grow" />
    </div> -->
    <!-- <CCardHeader>
	<CButton color="primary" class="px-4" @click="add()">Add new role with permission</CButton>
	</CCardHeader> -->
    <CRow>
      <CCol sm="12">
        <CTableWrapper
          :items="getShuffledRollsModulesData()"
          hover
          striped
          bordered
          small
          fixed
          caption="Assigned Modules List"
        />
      </CCol>
    </CRow>
  </div>
</template>

<script>
import CTableWrapper from "./Manage_assign_modules.vue";
import axios from "axios";
export default {
  name: "Manage_assign_module",
  components: { CTableWrapper },
  data() {
    return {
      roleOptions: [],
      modulesArr: [],
      roleArr: [],
      isLoading: false,
    };
  },
  mounted() {
    // var token=localStorage.getItem("auth");
    // var Session_User_Id=JSON.parse(localStorage.getItem("User_Id"));
    // var self = this;
    // 	var requestInfo = {
    // 		Token:token,
    // 		Session_User_Id:Session_User_Id,
    // 	};
    // 	//console.log(requestInfo);
    // 	var data = JSON.stringify(requestInfo);
    // 		var config = {
    // 		  method: 'post',
    // 		  url: apiURL+'ManageRole/GetRolesList',
    // 		  headers: {
    // 			'Content-Type': 'application/json'
    // 		  },
    // 		  data : data
    // 	};
    // 	axios(config)
    // 	.then(function (result) {
    // 		if(result.data.status_code==200){
    // 			var obj=result.data.response;
    // 			// //console.log(obj)
    // 			// var roleOptionsArr=obj;
    // 			// self.roleArr=obj;
    // 			// var roleSingleArr=[];
    // 			// var roleArr = roleOptionsArr.find(function(jsonitem, i){
    // 			// 	//console.log(jsonitem.Plant_Name)
    // 			// 	roleSingleArr.push(jsonitem.Role_Id);
    // 			// 	roleSingleArr.push(jsonitem.RoleName);
    // 			// });
    // 			self.roleOptions=obj;
    // 			// console.log(obj);
    // 		}else{
    // 			self.$swal.fire({
    // 			  icon: 'error',
    // 			  title: 'Oops...',
    // 			  text: result.data.message
    // 			})
    // 		}
    // })
    // var self1 = self;
    // var data = JSON.stringify(requestInfo);
    // 		var config = {
    // 		  method: 'post',
    // 		  url: apiURL+'ManageModule/GetModuleList',
    // 		  headers: {
    // 			'Content-Type': 'application/json'
    // 		  },
    // 		  data : data
    // 	};
    // axios(config)
    // 	.then(function (result) {
    // 		if(result.data.status_code==200){
    // 			var obj=result.data.response;
    // 			//console.log(obj)
    // 			// var modulecheckArr=obj;
    // 			self1.modulesArr=obj;
    // 			// console.log(obj);
    // 		}else{
    // 			self1.$swal.fire({
    // 			  icon: 'error',
    // 			  title: 'Oops...',
    // 			  text: result.data.message
    // 			})
    // 		}
    // })
    // .catch(function (error) {
    // 	//var errorObject=JSON.stringify(error.response.data.errors);
    // 	//console.log(errorObject);
    // 	self.$swal.fire({
    // 		icon: 'error',
    // 		title: 'Oops...',
    // 		text: 'Something went wrong!'
    // 	})
    // });
  },
  mounted() {
    this.isLoading = true;
  },
  methods: {
    shuffleArray(array) {
      for (let i = array.length - 1; i > 0; i--) {
        let j = Math.floor(Math.random() * (i + 1));
        let temp = array[i];
        array[i] = array[j];
        array[j] = temp;
      }
      return array;
    },
    getShuffledRollsModulesData() {
      var token = localStorage.getItem("auth");
      var Session_User_Id = JSON.parse(localStorage.getItem("User_Id"));
      /* role list */
      var self = this;
      var requestInfo = {
        Token: token,
        Session_User_Id: Session_User_Id,
      };
      //console.log(requestInfo);

      var rollsmodulesData = [];
      var data = JSON.stringify(requestInfo);
      var config = {
        method: "post",
        url: apiURL + "ManageRole/GetRolesList",
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
      axios(config).then((result) => {
        if (result.data.status_code == 200) {
          var obj = result.data.response;
          //console.log(obj);
          self.roleOptions = obj;

          /* module list */
          var self1 = self;
          var data = JSON.stringify(requestInfo);
          var config = {
            method: "post",
            url: apiURL + "ManageModule/GetModuleList",
            headers: {
              "Content-Type": "application/json",
            },
            data: data,
          };
          axios(config)
            .then((result) => {
              if (result.data.status_code == 200) {
                var obj = result.data.response;
                //console.log(obj);
                self1.modulesArr = obj;

                /* get assign list */
                var self2 = self1;
                var data = JSON.stringify(requestInfo);
                var config = {
                  method: "post",
                  url: apiURL + "ManageModule/GetRolePermissionList",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  data: data,
                };
                // console.log(config);
                axios(config)
                  .then((result) => {
                    setTimeout(() => {
                      this.isLoading = false;
                    }, 3000);
                    if (result.data.status_code == 200) {
                      var obj = result.data.response;
                      var totrow = obj.length;
                      for (var i = 0; i < totrow; i++) {
                        var roleArr = self2.roleOptions;
                        var RoleName = "";
                        var Role_Id = "";
                        var Rolefind = roleArr.find(function (jsonitem, f) {
                          if (jsonitem.Role_Id == obj[i].Role_Id) {
                            RoleName = jsonitem.RoleName;
                            Role_Id = jsonitem.Role_Id;
                          }
                        });

                        var moduleArr = self2.modulesArr;
                        var Module_names = "";
                        var nameArr = obj[i].Module_Ids.split(",");
                        for (var a = 0; a < nameArr.length; a++) {
                          if (a != 0) {
                            Module_names += ",";
                          }
                          var modulefind = moduleArr.find(function (
                            jsonitem,
                            f
                          ) {
                            if (jsonitem.Module_Id == nameArr[a]) {
                              Module_names += jsonitem.ModuleName;
                            }
                          });
                        }

                        var row = {
                          Item_Id: obj[i].Item_Id,
                          Role_Id: Role_Id,
                          RoleName: RoleName,
                          Module_Ids: Module_names,
                          action: "Edit",
                        };
                        //var row={ Role_Id:Role_Id,RoleName:RoleName, Module_Ids: Module_names, action: 'Edit'};

                        rollsmodulesData.push(row);
                      }
                    } else {
                      this.$swal.fire({
                        icon: "error",
                        title: "Oops...",
                        text: result.data.message,
                      });
                    }
                  })
                  .catch((error) => {
                    this.isLoading = false;
                    this.$swal.fire({
                      icon: "error",
                      title: "Oops...",
                      text: "Something went wrong!",
                    });
                  });
                /* get assign list */
              } else {
                this.isLoading = false;
                this.$swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: result.data.message,
                });
              }
            })

            .catch((error) => {
              //var errorObject=JSON.stringify(error.response.data.errors);
              //console.log(errorObject);
              this.isLoading = false;
              this.$swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Something went wrong!",
              });
            });
          /* module list */
        } else {
          this.isLoading = false;
          this.$swal.fire({
            icon: "error",
            title: "Oops...",
            text: result.data.message,
          });
        }
      });
      /* role list */

      return rollsmodulesData;
    },
  },
};
</script>
